<template>
  <div class="content-wrapper">
    <h2 class="page-titles">Redemption Pages</h2>
    <div class="gorder-button-wrapper">
      <div class="search-input">
        <SearchAndFilter :placeholder="'Search by email or name'" />
      </div>
      <button
        class="button-gemnote button-gemnote--small"
        @click="addNewGroupOrder"
      >
        <svg
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6 0L6 13" stroke="#F5F2EE" />
          <path d="M0 6.5L13 6.5" stroke="#F5F2EE" />
        </svg>

        <span> New Redemption Page</span>
      </button>
    </div>

    <div class="gorder-list">
      <Tabs :tabs="tabs" @setActiveTab="setActiveTab($event)" />
      <transition name="slide-fade">
        <GroupOrderActiveList v-if="tabs[0].isActive" />
        <GroupOrderCompletedList v-if="tabs[1].isActive" />
      </transition>
    </div>
  </div>
</template>

<script>
import { layouts, storeModules } from '../../helpers'
import store from '../../store'

export default {
  name: 'GroupOrderListMain',

  data() {
    return {
      tabs: [
        { name: 'Active', isActive: true },
        { name: 'Completed', isActive: false }
      ]
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (
      store.state.team.team.teamModuleNames.includes(storeModules.swag_store)
    ) {
      next()
    } else if (
      store.state.team.team.teamModuleNames.includes(storeModules.project)
    ) {
      next({ name: 'Projects' })
    }
  },
  components: {
    SearchAndFilter: () => import('@/components/Universal/SearchAndFilter'),
    GroupOrderActiveList: () =>
      import('@/components/GroupOrder/GroupOrderActiveList'),
    GroupOrderCompletedList: () =>
      import('@/components/GroupOrder/GroupOrderCompletedList'),
    Tabs: () => import('@/components/Universal/Tabs')
  },
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    this.$store.commit('groupOrder/CREATING_GROUP_ORDER_STEP', 1)
  },
  methods: {
    addNewGroupOrder() {
      this.$store.commit('groupOrder/SET_GROUP_ORDER_DETAILS', {})
      this.$router.push({ name: 'GroupOrderCreate' })
    },
    setActiveTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name === selectedTab.name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.gorder-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-items: flex-end;

  .search-input {
    width: 30%;
  }

  .button-gemnote {
    font-weight: normal;
    height: 2.5rem;
    padding: 0 24px !important;

    span {
      margin-left: 6px;
    }
  }
}

.gorder-list {
  margin-top: 5rem;
}

@media screen and (max-width: 630px) and (min-width: 350px) {
  .gorder-list {
    margin-top: 2rem;
  }
  .gorder-button-wrapper {
    display: flex;
    gap: 1.5rem;
    flex-direction: column;
    align-items: flex-end;

    .search-input {
      flex: 0;
      width: 100%;
    }
  }
}
</style>
